import React from 'react';
import {useFormContext} from "react-hook-form";
import {useDispatch} from "react-redux";

import css from './OrdersSingleDayModal.module.css';
import {ordersActions} from "../../../../store/slices/orders-slices";


const OrdersSingleDayModal = ({
                                  period,
                                  setDays,
                                  setSelectedDates,
                                  lastSelectedDate,
                                  watchSat,
                                  watchSun
                              }) => {
    const dispatch = useDispatch();
    const {setValue} = useFormContext();

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Якщо чекбокс активний — день заблоковано
    const isDateActive = (date) => {
        if (watchSat && date.getDay() === 6) return false;
        if (watchSun && date.getDay() === 0) return false;
        return true;
    };

    const getNextDays = (count, startFrom = new Date()) => {
        const result = [];
        const start = new Date(startFrom);
        let i = 0;
        while (result.length < count) {
            const candidate = new Date(start);
            candidate.setDate(start.getDate() + i);
            if (isDateActive(candidate)) {
                result.push(formatDate(candidate));
            }
            i++;
        }
        return result;
    };

    const handleDayClick = (e) => {
        e.preventDefault();
        setValue('days count', period.daysCount);
        setDays(period.daysCount);

        dispatch(ordersActions.changeCurrentDiscount(period.discount));

        const baseDate = lastSelectedDate || new Date();
        const newDates = getNextDays(period.daysCount, baseDate);
        setSelectedDates(newDates);
    };


    return (
        <div className={css.dayBlock} onClick={handleDayClick}>
            <div className={css.currentDays}>{period.daysCount}</div>

            <div className={css.text}>days</div>

            <div className={css.discount}>-{period.discount}%</div>
        </div>
    );
};

export {OrdersSingleDayModal};
